/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Download_FailedInputs */

const en_invoice_download_failed = /** @type {(inputs: Invoice_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open the invoice. Try again.`)
};

const pl_invoice_download_failed = /** @type {(inputs: Invoice_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się otworzyć faktury. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not open the invoice. Try again." |
*
* @param {Invoice_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_download_failed = /** @type {((inputs?: Invoice_Download_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Download_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_download_failed(inputs)
	return en_invoice_download_failed(inputs)
});